import { useMemo } from "react";
import { useSelector } from "react-redux";
import { HotelsShopSelectors } from "@b2bportal/core-hotels";
import { toMapCoordinatesType } from "@overrides/utilities";
import type { HotelShopMapComponentProps } from "../component";
import { useGetMapInfoFromStay } from "./useGetMapInfoFromStay";

export const useHotelShopMap = ({ hotel }: HotelShopMapComponentProps) => {
  const search = useSelector(HotelsShopSelectors.getShopSearch);

  const { coordinates, hotelName, address } = useGetMapInfoFromStay(hotel);

  return useMemo(() => {
    return {
      context: {
        search,
        coordinates,
        //Google static maps requires hex colors to start with 0x
        markerColor: "0x2A1050",
        hotel,
        mapCoordinates: toMapCoordinatesType(coordinates),
      },
      text: {
        hotelName,
        address,
      },
    };
  }, [address, coordinates, hotel, hotelName, search]);
};
